export const BookSymbol = Symbol('book');
